import { connect } from 'react-redux';
import compose from 'lodash.flowright';
import { graphql } from 'react-apollo';
import { withRouter } from 'react-router-dom';

import { requestConfirm } from '../../../../../../actions/modal-actions';
import { AlbumWithCoverPhotos } from '../../../../../../graphql/queries/albums';
import { albumUpdate } from '../../../../../../graphql/mutations/albums';
import { AlbumFolderWithCoverPhotos } from '../../../../../../graphql/queries/album-folder';
import { albumFolderUpdate } from '../../../../../../graphql/mutations/album-folder';
import CoverPhotoButton from './CoverPhotoButton';

const withAlbumWithCoverPhotos = graphql(AlbumWithCoverPhotos, {
  options: ({ match }) => ({
    variables: {
      albumId: match.params.albumId,
      limit: 25,
      offset: 0,
    },
    fetchPolicy: 'cache-and-network',
  }),
  props: ({ data: { album, loading } }) => ({
    album,
    loading,
  }),
  skip: ({ match, skipQueries }) => !match.params.albumId || skipQueries,
});

const withAlbumFolderAndCoverPhotos = graphql(AlbumFolderWithCoverPhotos, {
  options: ({ match }) => ({
    variables: {
      albumFolderId: match.params.folderId || match.params.albumFolderId,
      limit: 25,
      offset: 0,
    },
    fetchPolicy: 'cache-and-network',
  }),
  props: ({ data: { albumFolder, loading } }) => ({
    albumFolder,
    loading,
  }),
  skip: ({ match, skipQueries }) =>
    (!match.params.folderId && !match.params.albumFolderId) || skipQueries,
});

const withAlbumUpdateMutation = graphql(albumUpdate, {
  props: ({ mutate }) => ({
    updateAlbum: album =>
      mutate({
        variables: {
          input: album,
        },
      }),
  }),
});

const withAlbumFolderUpdateMutation = graphql(albumFolderUpdate, {
  props: ({ mutate }) => ({
    updateAlbumFolder: folder =>
      mutate({
        variables: {
          input: {
            ...folder,
          },
        },
      }),
  }),
});

const mapDispatchToProps = {
  requestConfirm,
};

export default compose(
  withRouter,
  connect(null, mapDispatchToProps),
  withAlbumUpdateMutation,
  withAlbumFolderUpdateMutation,
  withAlbumWithCoverPhotos,
  withAlbumFolderAndCoverPhotos,
)(CoverPhotoButton);
